module.exports = __webpack_public_path__ + "img/project-pic7.a31db582.png";